namespace Matrix.Data {
    export interface AccountModelTargetExportRequest extends Serenity.ServiceRequest {
        ModelCode?: string;
        AccountCodes?: string[];
    }
}
